import PlayCircleOutlined from '@ant-design/icons/PlayCircleOutlined';
import SaveOutlined from '@ant-design/icons/SaveOutlined';
import Button from 'antd/es/button';
import { type FormInstance } from 'antd/es/form';
import styled from 'styled-components';

import { type TemplateFormData } from './types';

import MarkdownContent from '@components/MarkdownContent';

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

const ScrollablePreview = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fafafa;
`;

type TemplatePreviewStepProps = {
  renderedPreview: string | undefined;
  form: FormInstance<TemplateFormData>;
  onCreateDraft: () => void;
  onCreateAndStart: () => void;
  hideButtons?: boolean;
};

const TemplatePreviewStep = ({
  renderedPreview,
  form,
  onCreateDraft,
  onCreateAndStart,
  hideButtons = false,
}: TemplatePreviewStepProps) => {
  return (
    <div>
      {renderedPreview ? (
        <ScrollablePreview>
          <MarkdownContent content={renderedPreview} />
        </ScrollablePreview>
      ) : (
        <p>Complete previous steps to see the preview</p>
      )}

      {!hideButtons && (
        <ActionButtons>
          <Button
            icon={<SaveOutlined />}
            onClick={() => {
              void form.validateFields().then(() => {
                onCreateDraft();
              });
            }}
            htmlType="button"
          >
            Create Draft
          </Button>
          <Button
            type="primary"
            icon={<PlayCircleOutlined />}
            onClick={() => {
              void form.validateFields().then(() => {
                onCreateAndStart();
              });
            }}
            htmlType="button"
          >
            Create & Start
          </Button>
        </ActionButtons>
      )}
    </div>
  );
};

export default TemplatePreviewStep;
